import {
  GET_PROJECTS_SUCCESS,
  GET_PROJECT_SUCCESS,
  CREATE_PROJECT_SUCCESS,
  EDIT_PROJECT_SUCCESS,
  DELETE_PROJECT_SUCCESS,
  ADD_MEMBER_SUCCESS,
  REMOVE_MEMBER_SUCCESS,
} from './project.types';

const initialState = {
  projects: [],
  project: null,
};

export const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS_SUCCESS:
      return { ...state, projects: action.payload };
    case GET_PROJECT_SUCCESS:
      return { ...state, project: action.payload };
    case CREATE_PROJECT_SUCCESS:
      return { ...state, projects: [...state.projects, action.payload] };
    case EDIT_PROJECT_SUCCESS:
      return {
        ...state,
        project: action.payload,
        projects: state.projects.map((p) =>
          p._id === action.payload._id ? action.payload : p
        ),
      };
    case DELETE_PROJECT_SUCCESS:
      return {
        ...state,
        projects: state.projects.filter((p) => p._id !== action.payload),
      };
    case ADD_MEMBER_SUCCESS:
    case REMOVE_MEMBER_SUCCESS:
      return { ...state, project: action.payload };
    default:
      return state;
  }
};
